import React, {FC, useEffect, useRef, useState} from 'react';
import {useSearchQuery} from 'services/search';
import Box from "@mui/material/Box";
import Search from "../../../components/ui/Search";

interface ISearchContainerProps {
    action?: React.ReactNode;
}

const SearchContainer: FC<ISearchContainerProps> = ({action}) => {
    const [inputValue, setInputValue] = useState('');
    const {data: searchResultsData, isFetching} = useSearchQuery(
        {q: inputValue},
        {skip: !inputValue}
    );

    const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const debounceSetInputValue = (
        newInputValue: string,
        delay: number = 500
    ) => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            setInputValue(newInputValue);
        }, delay);
    };

    const handleTextInputChange = (_: React.SyntheticEvent, newInputValue: string) => {
        debounceSetInputValue(newInputValue);
    };

    const getOptions = () => {
        const results = searchResultsData?.results;

        if (!results) {
            return [];
        }

        return Object.entries(results).flatMap(([key, value]) => {
            if (Array.isArray(value) && value.length > 0) {
                return value.map((item) => ({
                    ...item,
                    type: key,
                }));
            }
            return [];
        });
    };

    useEffect(() => {
        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, []);

    return (
        <Box>
            <Search
                placeholder="Search for Trucks, Locations, Orders, and Customers"
                resultData={getOptions()}
                isLoading={isFetching}
                onTextInput={handleTextInputChange}
            />
            {action}
        </Box>
    );
};

export default SearchContainer;
